import React from 'react';
import CallIcon from '@material-ui/icons/Call';
const CallMessage = ({message}) => {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            padding: '4px 0',
        }}>
            <CallIcon color="#8696a0"/>
            <p style={{
                fontWeight: 500,
                color: '#8696a0',
            }}>
                {message?.content}
            </p>
        </div>
    );
};

export { CallMessage };